import { mapNullable } from 'annotation-tools/utils';
import { hueToDefaultHex } from '../../../functions/hue-to-hex';
import {
  LabelAPIRawRequestBodyType,
  LabelAPIRequestBodyType
} from '../../types/label/api-request-body';

export const LabelAPIRequestBody = ({
  name,
  hue
}: LabelAPIRequestBodyType): LabelAPIRawRequestBodyType => ({
  name,
  color: hueToDefaultHex(hue)
});

export const LabelAPIRequestBodyPartial = ({
  name,
  hue
}: Partial<LabelAPIRequestBodyType>): Partial<LabelAPIRawRequestBodyType> => ({
  name,
  color: mapNullable(hue, hueToDefaultHex)
});
